module.exports = __webpack_public_path__ + "media/images/common/ico-btn-notice-on-4817d1e64860b6506e7609bd306199e3.svg";